





































































































import {Component} from 'vue-property-decorator';
import {Getter, Action} from "vuex-class";
import DistributionsFilter from "@/components/Distributions/DistributionsFilter.vue";
import {DistributionItem} from "@/store/templates/types";
import {LongTextWings} from '@/components';
import ScrollButton from "@/components/ScrollButton.vue";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {dateFilter} from "@/utils/date-util";
import {notifyDelete, notifyError} from "@/utils/notify-helper";

@Component({components: {DistributionsFilter,LongTextWings,ScrollButton}, filters: {dateFilter}})
export default class Distributions extends BaseItemsPage<DistributionItem> {
  @Getter("distributions") distributions: any;
  @Action("startDistribution") actionStartDistribution: any;
  @Action("stopDistribution") actionStopDistribution: any;
  @Action("pauseDistribution") actionPauseDistribution: any;
  @Action("resumeDistribution") actionResumeDistribution: any;

  is_show_filter = false;
  filterClone: any = {};
  runFilter: boolean = false;

  currentSort = "ID";
  currentSortOrder = "desc";

  tableFields = [
    'batchId',
    'createDatetime',
    'recipient',
    'transport',
    'status',
    'comment',
    'startDatetime',
    'endDatetime'
  ];

  getData(): any {
    return this.distributions;
  }

  async startItem(item: any) {
    if (!await notifyDelete(this.$t('distribution.dialog.start').toString())) return
    try {
      await this.actionStartDistribution(item.batchId)
      this.runFilter = true;
    } catch(error) {
      notifyError(error);
    }
  }

  async stopItem(item: any) {
    if (!await notifyDelete(this.$t('distribution.dialog.stop').toString())) return
    try {
      await this.actionStopDistribution(item.batchId)
      this.runFilter = true;
    } catch(error) {
      notifyError(error);
    }
  }

  statusItemColor(status:string): string {
    switch (status) {
      case 'IN_PROGRESS':
        return 'background-chip-success'
      case 'FINISHED':
        return 'background-chip-info'
      case 'PAYMENT_WAITING':
        return 'background-chip-secondary'
      case 'ERROR':
      case 'DENIED':
        return 'background-chip-danger'
      default:
        return 'background-chip-warning'
    }
  }

}
